import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

const indexesByCollection = new WeakMap<ReadonlyArray<{id: Uuid}>, ReadonlyMap<Uuid, {id: Uuid}>>();

/** Memoized per collection instance so the resolver and GeographyProvider share one index. */
export function indexById<TItem extends {id: Uuid}>(items: ReadonlyArray<TItem>): ReadonlyMap<Uuid, TItem> {
    let index = indexesByCollection.get(items);
    if (index === undefined) {
        index = new Map(items.map((item) => [item.id, item]));
        indexesByCollection.set(items, index);
    }
    return index as ReadonlyMap<Uuid, TItem>;
}
